/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConversationalAgentProtocolEnum } from './ConversationalAgentProtocolEnum';
import {
  ConversationalAgentProtocolEnumFromJSON,
  ConversationalAgentProtocolEnumFromJSONTyped,
  ConversationalAgentProtocolEnumToJSON,
} from './ConversationalAgentProtocolEnum';

/**
 * POST body discriminated by ``protocol``: dispatches to the correct per-protocol
 * create serializer. Validation and persistence are handled by the concrete serializer.
 * @export
 * @interface ConversationalAgentInferencerCreatePolymorphicShared
 */
export interface ConversationalAgentInferencerCreatePolymorphicShared {
  /**
   *
   * @type {ConversationalAgentProtocolEnum}
   * @memberof ConversationalAgentInferencerCreatePolymorphicShared
   */
  protocol: ConversationalAgentProtocolEnum;
  /**
   *
   * @type {string}
   * @memberof ConversationalAgentInferencerCreatePolymorphicShared
   */
  credentialValue?: string | null;
}

/**
 * Check if a given object implements the ConversationalAgentInferencerCreatePolymorphicShared interface.
 */
export function instanceOfConversationalAgentInferencerCreatePolymorphicShared(
  value: object,
): value is ConversationalAgentInferencerCreatePolymorphicShared {
  if (!('protocol' in value) || value['protocol'] === undefined) return false;
  return true;
}

export function ConversationalAgentInferencerCreatePolymorphicSharedFromJSON(
  json: any,
): ConversationalAgentInferencerCreatePolymorphicShared {
  return ConversationalAgentInferencerCreatePolymorphicSharedFromJSONTyped(json, false);
}

export function ConversationalAgentInferencerCreatePolymorphicSharedFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ConversationalAgentInferencerCreatePolymorphicShared {
  if (json == null) {
    return json;
  }
  return {
    protocol: ConversationalAgentProtocolEnumFromJSON(json['protocol']),
    credentialValue: json['credential_value'] == null ? undefined : json['credential_value'],
  };
}

export function ConversationalAgentInferencerCreatePolymorphicSharedToJSON(
  value?: ConversationalAgentInferencerCreatePolymorphicShared | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    protocol: ConversationalAgentProtocolEnumToJSON(value['protocol']),
    credential_value: value['credentialValue'],
  };
}
